import { render, staticRenderFns } from "./BasicInfoDisplay.vue?vue&type=template&id=53017f45&scoped=true"
import script from "./BasicInfoDisplay.vue?vue&type=script&lang=js"
export * from "./BasicInfoDisplay.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoDisplay.vue?vue&type=style&index=0&id=53017f45&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53017f45",
  null
  
)

export default component.exports